// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"224":"990dc85d79f9448b1964","846":"329252ec5b15be3bcc6b","940":"85d7b0552af0e73da387","996":"1855f777583dabf038ef"}[chunkId] + ".js";
};